"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.transformDomainUBOToMangopayCreateUBO = transformDomainUBOToMangopayCreateUBO;
exports.transformDomainUBOToMangopayUpdateUBO = transformDomainUBOToMangopayUpdateUBO;
const transformDateToMangopayTimestamp_1 = require("./transformDateToMangopayTimestamp");
const transformDomainCountryToMangopayCountry_1 = require("./transformDomainCountryToMangopayCountry");
function transformDomainUBOToMangopayCreateUBO(ubo) {
    return {
        ...getBaseUBOData(ubo),
    };
}
function transformDomainUBOToMangopayUpdateUBO(ubo) {
    return {
        Id: ubo.id,
        ...getBaseUBOData(ubo),
    };
}
function getBaseUBOData(ubo) {
    return {
        FirstName: ubo.firstName,
        LastName: ubo.lastName,
        Address: {
            AddressLine1: ubo.address.addressLine1,
            AddressLine2: ubo.address.addressLine2,
            City: ubo.address.city,
            Country: (0, transformDomainCountryToMangopayCountry_1.transformDomainCountryToMangopayCountry)(ubo.address.countryISOCode),
            Region: ubo.address.region,
            PostalCode: ubo.address.postalCode,
        },
        Nationality: ubo.nationalityCountryISOCode,
        Birthday: (0, transformDateToMangopayTimestamp_1.transformDateToMangopayTimestamp)(ubo.birthdayAt),
        Birthplace: {
            City: ubo.birtplace.city,
            Country: (0, transformDomainCountryToMangopayCountry_1.transformDomainCountryToMangopayCountry)(ubo.birtplace.countryISOCode),
        },
    };
}
//# sourceMappingURL=transformUBO.js.map